
export const environment = {
  production: false,
  commonPaymentApiBasePath : 'https://preprod.paybyphone.cinchhs.com/commonPayment/',
  ivrCallTransfer: 'https://apis.preprod.accelerate.cinchhs.com/paymentsvc/api/callmonitor/',
  originalPaymentUIDomain: 'https://preprod.payment.cinchhs.com/'
};
